export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 200];
export const PAGE_SIZE_STORAGE_KEY = 'leads_page_size';
export const KANBAN_COL_PAGE_SIZE_KEY = 'leads_kanban_col_page_size';

export function loadPageSize() {
  const v = parseInt(localStorage.getItem(PAGE_SIZE_STORAGE_KEY), 10);
  return PAGE_SIZE_OPTIONS.includes(v) ? v : 25;
}

export function savePageSize(v) {
  localStorage.setItem(PAGE_SIZE_STORAGE_KEY, String(v));
}

export function loadKanbanColPageSize() {
  const v = parseInt(localStorage.getItem(KANBAN_COL_PAGE_SIZE_KEY), 10);
  return PAGE_SIZE_OPTIONS.includes(v) ? v : 10;
}

export function saveKanbanColPageSize(v) {
  localStorage.setItem(KANBAN_COL_PAGE_SIZE_KEY, String(v));
}

export default function PageSizeSelect({ value, onChange, testId = 'page-size-select', label = 'Resultados por página:' }) {
  return (
    <label className="flex items-center gap-1.5 text-xs text-[#6B7280]">
      {label}
      <select
        data-testid={testId}
        value={value}
        onChange={e => onChange(parseInt(e.target.value, 10))}
        className="px-2 py-1 text-xs border border-[#E5E7EB] rounded bg-white text-[#374151] cursor-pointer focus:ring-2 focus:ring-[#0F1829]/20 outline-none"
      >
        {PAGE_SIZE_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </label>
  );
}
